import _objectSpread from "/data/jenkins/workspace/wyt-admin/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, mergeProps as _mergeProps, isRef as _isRef } from "vue";

const _hoisted_1 = /*#__PURE__*/_createTextVNode("查询");

const _hoisted_2 = {
  key: 1
};

const _hoisted_3 = /*#__PURE__*/_createTextVNode("取消");

const _hoisted_4 = /*#__PURE__*/_createTextVNode("确认");

import { ref, computed, watch } from 'vue';
import { getVexTableProps } from '@/config';
import { getVarietyList } from '@/request';
import { ElMessage } from 'element-plus';
export default {
  name: 'AddVarietyModal',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    beforeSuccess: {
      type: [Function, null],
      default: null
    },
    selectedIds: {
      type: Array,
      default: () => []
    },
    checkMode: {
      type: String,
      default: 'radio'
    }
  },
  emits: ['update:modelValue', 'success'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const table = ref();
    const visible = computed({
      get() {
        return props.modelValue;
      },

      set(val) {
        emit('update:modelValue', val);
      }

    });
    const form = ref({
      prodName: ''
    });
    watch(() => props.modelValue, newVal => {
      if (newVal) {
        form.value = {
          prodName: ''
        };
      }
    });
    const tableOptions = getVexTableProps({
      columns: [{
        type: props.checkMode,
        width: '50px'
      }, {
        title: '主图',
        field: 'coverUrl',
        width: '80px',
        slots: {
          default: 'cover'
        }
      }, {
        title: '品种名称',
        field: 'prodName',
        minWidth: '200px',
        showOverflow: true
      }, {
        title: '商品ID',
        field: 'goodsId',
        width: '140px',
        showOverflow: true
      }],
      proxyConfig: {
        ajax: {
          query: ({
            page
          }) => new Promise(res => {
            getVarietyList(_objectSpread({
              page: page.currentPage,
              pageSize: page.pageSize,
              status: 1
            }, form.value)).then(data => {
              res({
                total: data.data.totalSize,
                result: data.data.list
              });
            });
          })
        }
      },
      checkboxConfig: {
        checkMethod({
          row
        }) {
          return !props.selectedIds.find(i => i === row.varietyId);
        }

      },
      radioConfig: {
        checkMethod({
          row
        }) {
          return !props.selectedIds.find(i => i === row.varietyId);
        }

      }
    });

    function confirm() {
      const selectRows = props.checkMode === 'radio' ? table.value.getRadioRecord() : table.value.getCheckboxRecords();

      if (props.checkMode === 'radio' && !selectRows || props.checkMode === 'checkbox' && selectRows.length === 0) {
        ElMessage.warning('请勾选后再进行操作!');
        return;
      }

      if (typeof props.beforeSuccess === 'function') {
        if (props.beforeSuccess(selectRows)) {
          emit('success', selectRows);
          visible.value = false;
        }
      } else {
        emit('success', selectRows);
        visible.value = false;
      }
    }

    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_form = _resolveComponent("el-form");

      const _component_el_image = _resolveComponent("el-image");

      const _component_vxe_grid = _resolveComponent("vxe-grid");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createBlock(_component_el_dialog, {
        title: "选择品种",
        modelValue: _unref(visible),
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _isRef(visible) ? visible.value = $event : null),
        "destroy-on-close": "",
        "append-to-body": "",
        width: "1000px",
        top: "30px"
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: _cache[2] || (_cache[2] = $event => visible.value = false)
        }, {
          default: _withCtx(() => [_hoisted_3]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: confirm
        }, {
          default: _withCtx(() => [_hoisted_4]),
          _: 1
        })]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          inline: true
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "品种名称"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.value.prodName,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.value.prodName = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: ""
          }, {
            default: _withCtx(() => [_createVNode(_component_el_button, {
              icon: "Search",
              type: "primary",
              onClick: _cache[1] || (_cache[1] = $event => table.value.commitProxy('reload'))
            }, {
              default: _withCtx(() => [_hoisted_1]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_vxe_grid, _mergeProps({
          height: "630px",
          ref_key: "table",
          ref: table
        }, _unref(tableOptions)), {
          cover: _withCtx(({
            row
          }) => [row.coverUrl ? (_openBlock(), _createBlock(_component_el_image, {
            key: 0,
            style: {
              "width": "48px",
              "height": "48px"
            },
            src: row.coverUrl,
            fit: "cover"
          }, null, 8, ["src"])) : (_openBlock(), _createElementBlock("span", _hoisted_2, "-"))]),
          _: 1
        }, 16)]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }

};